<template>
    <div class="tipo-contacto-select-wrapper">
        <dynamicSelectVue
            ref="dynamicSelect"
            title="Tipo de contacto"
        :estados="estados"
        show="nombre"
        itemvalue="nombre"
        v-model="valor"
        outlined
        :disabled="disabled"
        :rules="rules"
        @create="save"
        @delete="destroy"
        @getEstado="getById"
        @getItem="setSelectedItem"
        @update="save"
        @changeElement="change"
    >
        <v-form ref="form" v-model="validForm">
            <v-row class="mt-3">
                <v-col cols="12">
                    <v-text-field
                        outlined
                        v-model="selectedItem.nombre"
                        label="Nombre del tipo"
                        :rules="[rules.required]"
                        dense
                    ></v-text-field>
                </v-col>
            </v-row>
        </v-form>
    </dynamicSelectVue>
    </div>
</template>
<script>
import dynamicSelectVue from "./dynamicSelect.vue";
import { rules } from "../../rules";
export default {
    name: "TipoContactoSelect",
    components: {
        dynamicSelectVue,
    },
    props: {
        value: {
            type: String,
            default: null,
        },
        estados: {
            type: Array,
            default: () => [],
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        rules: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            validForm: true,
            rules: rules,
            valor: null,
            selectedItem: {
                id: null,
                nombre: "",
            },
        };
    },
    created() {
        this.valor = this.value;
    },
    watch: {
        value(val) {
            this.valor = val;
        },
        valor(val) {
            this.$emit("input", val);
        },
    },
    methods: {
        save() {
            this.$refs.form.validate();
            if (!this.validForm) return;

            if (this.selectedItem.id != null) {
                this.$emit("update", { ...this.selectedItem });
            } else {
                const nombre = (this.selectedItem.nombre || "").trim();
                if (nombre) this.$emit("create", nombre);
            }
            this.clearSelectedItem();
            if (this.$refs.dynamicSelect) this.$refs.dynamicSelect.closeDialog();
        },
        destroy(id) {
            this.$emit("delete", id);
            this.clearSelectedItem();
            if (this.$refs.dynamicSelect) this.$refs.dynamicSelect.closeDialog();
        },
        getById(id) {
            const item = this.estados.find((e) => e.id === id || e.id == id);
            this.selectedItem = item
                ? { id: item.id, nombre: item.nombre }
                : { id: null, nombre: "" };
        },
        setSelectedItem(item) {
            this.selectedItem = item && item.nombre !== undefined
                ? { id: item.id, nombre: item.nombre }
                : { id: null, nombre: "" };
        },
        change() {
            if (this.$refs.dynamicSelect) this.$refs.dynamicSelect.closeDialog();
        },
        clearSelectedItem() {
            this.selectedItem = { id: null, nombre: "" };
        },
    },
};
</script>
<style scoped>
.tipo-contacto-select-wrapper {
    min-width: 0;
    margin-bottom: 4px;
}
</style>
